"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _EyeIcon = _interopRequireDefault(require("./EyeIcon"));

var _index = require("../../../../index");

var _reactRedux = require("react-redux");

var _helpers = require("../../../helpers");

var _AttributeHeader = _interopRequireDefault(require("./IndividualTable/AttributeHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IndividualTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(IndividualTable, _React$Component);

  function IndividualTable(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "getMaxValues", function () {
      var unformattedPersonas = _this.props.unformattedPersonas;

      if (unformattedPersonas.length <= 0) {
        return {};
      }

      return {
        index: (0, _helpers.getMaxArrayValue)(unformattedPersonas, 'index'),
        population: (0, _helpers.getMaxArrayValue)(unformattedPersonas, 'population'),
        shareOfSegment: (0, _helpers.getMaxArrayValue)(unformattedPersonas, 'shareOfSegment'),
        shareOfProperty: (0, _helpers.getMaxArrayValue)(unformattedPersonas, 'shareOfProperty')
      };
    });

    _defineProperty(_assertThisInitialized(_this), "formatDataForCharacteristic", function (answer) {
      var selectedMeasure = _this.props.selectedMeasure;
      var dataPoint = answer[selectedMeasure];

      switch (selectedMeasure) {
        case 'index':
          return Math.round(dataPoint);

        case 'population':
          return (0, _helpers.formatAsThousands)(dataPoint);

        case 'shareOfProperty':
        case 'shareOfSegment':
          return (0, _helpers.formatAsPercent)(dataPoint);

        default:
          return dataPoint;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "barStyle", function (record, characteristic, maxIndexObject) {
      var _this$props = _this.props,
          selectedMeasure = _this$props.selectedMeasure,
          communityColours = _this$props.communityColours;
      var backgroundColor = communityColours[record.segmentId] ? communityColours[record.segmentId] : communityColours[Math.floor(record.segmentId / 100) * 100];
      return {
        width: record.answers[characteristic.answerId][selectedMeasure] / maxIndexObject[selectedMeasure] * 100 + '%',
        backgroundColor: backgroundColor
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleSortChange", function (clickedColumn) {
      return function () {
        return (0, _helpers.sortChangeHandler)(clickedColumn, _assertThisInitialized(_this));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "sort", function (a, b) {
      var sortColumn = _this.state.sortColumn;
      var _this$props2 = _this.props,
          selectedCharacteristics = _this$props2.selectedCharacteristics,
          selectedMeasure = _this$props2.selectedMeasure;

      if (selectedCharacteristics.characteristics.filter(function (characteristic) {
        return characteristic.answerId === sortColumn;
      }).length > 0) {
        return (0, _helpers.sortAnswerData)(a, b, selectedMeasure, _assertThisInitialized(_this));
      } else {
        return (0, _helpers.sortData)(a, b, _assertThisInitialized(_this));
      }
    });

    _this.state = {
      sortColumn: 'segmentId',
      sortDirection: 'ascending'
    };
    return _this;
  }

  var _proto = IndividualTable.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (this.state.sortColumn !== 'segmentId' && this.props.selectedCharacteristics.characteristics.filter(function (characteristic) {
      return characteristic.answerId === _this2.state.sortColumn;
    }).length <= 0) {
      this.setState({
        sortColumn: 'segmentId',
        sortDirection: 'ascending'
      });
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props3 = this.props,
        individualPersonaRecords = _this$props3.individualPersonaRecords,
        selectedCharacteristics = _this$props3.selectedCharacteristics,
        selectedPersonas = _this$props3.selectedPersonas,
        handleSelectPersona = _this$props3.handleSelectPersona,
        selectedMeasure = _this$props3.selectedMeasure,
        hideUnselectedPersonas = _this$props3.hideUnselectedPersonas,
        handleHideUnselectedPersonas = _this$props3.handleHideUnselectedPersonas,
        isFetching = _this$props3.isFetching,
        audienceView = _this$props3.audienceView,
        superSegments = _this$props3.superSegments,
        removeSelectedCharacteristic = _this$props3.removeSelectedCharacteristic,
        displaySegmentIds = _this$props3.displaySegmentIds;
    var maxValues = this.getMaxValues();
    var _this$state = this.state,
        sortColumn = _this$state.sortColumn,
        sortDirection = _this$state.sortDirection;
    var tooSmallSample = /*#__PURE__*/React.createElement("span", {
      className: "table__sample-small"
    }, "Below reportable threshold.");
    var leadCellMessage = audienceView.textSingular; // don't attempt to render anything unless there are selectedCharacteristics

    if (selectedCharacteristics && selectedCharacteristics.characteristics.length) {
      var columnStyle = {};

      if (selectedCharacteristics.characteristics.length > 5) {
        columnStyle = {
          width: '220px'
        };
      }

      var TableHeader = /*#__PURE__*/React.createElement(_semanticUiReact.Table.Header, {
        className: "data-workflow-table__header"
      }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/React.createElement(_semanticUiReact.Table.HeaderCell, {
        className: "data-workflow-table__fixed-column data-workflow-table__lead-cell",
        sorted: sortColumn === 'segmentId' ? sortDirection : null,
        onClick: this.handleSortChange('segmentId')
      }, /*#__PURE__*/React.createElement(_EyeIcon["default"], {
        audienceView: audienceView,
        hideUnselectedPersonas: hideUnselectedPersonas,
        handleHideUnselectedPersonas: handleHideUnselectedPersonas
      }), leadCellMessage), selectedCharacteristics.characteristics.map(function (characteristic, key) {
        return /*#__PURE__*/React.createElement(_AttributeHeader["default"], {
          key: key,
          characteristic: characteristic,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
          columnStyle: columnStyle,
          handleSortChange: _this3.handleSortChange,
          removeSelectedCharacteristic: removeSelectedCharacteristic
        });
      })));
      var rows = individualPersonaRecords ? Object.values(individualPersonaRecords).sort(this.sort) : [];
      rows = rows.map(function (record, key) {
        return /*#__PURE__*/React.createElement(_semanticUiReact.Table.Row, {
          className: "data-workflow-table__row",
          key: key
        }, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, {
          collapsing: true,
          className: "data-workflow-table__fixed-column data-workflow-table__lead-cell"
        }, /*#__PURE__*/React.createElement(_semanticUiReact.Checkbox, {
          className: "data-workflow-table__checkbox",
          checked: selectedPersonas.filter(function (persona) {
            return parseInt(persona.id) === parseInt(record.segmentId);
          }).length > 0 ? true : false,
          onClick: function onClick() {
            return handleSelectPersona(record.segmentId, record.segmentLabel);
          },
          value: record.segmentId,
          label: (displaySegmentIds ? record.segmentId : '') + " " + (audienceView.segmentType === 'supersegments' ? (0, _helpers.selectCommunityDescription)(record.segmentId, superSegments) : record.segmentLabel)
        })), selectedCharacteristics.characteristics.map(function (characteristic, key2) {
          if (record.answers && record.answers[characteristic.answerId]) {
            return /*#__PURE__*/React.createElement(_semanticUiReact.Table.Cell, {
              "data-point": record.answers[characteristic.answerId][selectedMeasure],
              key: key2
            }, record.answers[characteristic.answerId].belowSample ? tooSmallSample : /*#__PURE__*/React.createElement("div", {
              className: "data-workflow-table__index-wrapper"
            }, /*#__PURE__*/React.createElement("span", {
              className: "data-workflow-table__index-bar",
              style: _this3.barStyle(record, characteristic, maxValues)
            }), /*#__PURE__*/React.createElement("span", {
              className: "data-workflow-table__index-data"
            }, _this3.formatDataForCharacteristic(record.answers[characteristic.answerId]))));
          } else {
            return '';
          }
        }));
      });

      if (isFetching) {
        return /*#__PURE__*/React.createElement(_index.LoadingIndicator, null);
      }

      return /*#__PURE__*/React.createElement(_semanticUiReact.Table, {
        sortable: true,
        fixed: true,
        striped: true,
        className: "grouped-persona-table"
      }, TableHeader, /*#__PURE__*/React.createElement(_semanticUiReact.Table.Body, null, rows));
    } else {
      return /*#__PURE__*/React.createElement("h3", {
        className: "data-workflow-table__no-results"
      }, "Select answers to the questions on the left to view data");
    }
  };

  return IndividualTable;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    superSegments: state.superSegments.bySlug,
    // TODO: Finish off changing to superSegments
    audienceView: state.audienceView.view,
    displaySegmentIds: state.options.displaySegmentIds.value
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, undefined)(IndividualTable);

exports["default"] = _default;